export default __webpack_public_path__ + "static/media/(3).8ba5f1b5.jpg";